var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 66,
    viewBox: "0 0 183 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1582 33.7297C16.5136 41.9027 25.9876 45.827 34.2774 42.5189C37.0077 41.4162 39.3762 39.6324 41.1197 37.2973C43.0935 34.6703 46.8436 34.1514 49.5082 36.0973C52.1727 38.0433 52.6991 41.7405 50.7253 44.3676C41.3829 56.6595 23.7178 59.1568 11.2831 49.9459C7.17113 46.9297 4.01312 42.8432 2.07227 38.173L13.1582 33.7297Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2787 27.7946C60.1012 42.0324 53.1273 58.2162 38.686 63.9567C24.2447 69.6973 7.82962 62.8216 2.00704 48.5837C0.789895 45.5351 2.30311 42.1297 5.36243 40.9297C8.42175 39.7297 11.8758 41.1891 13.1259 44.1729C16.4812 52.3459 25.9224 56.3027 34.2122 52.9946C42.5019 49.6864 46.5152 40.3783 43.1598 32.2054L54.2787 27.7946Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1593 32.2054C39.804 24.0324 30.3628 20.1081 22.0731 23.4162C19.3756 24.4864 17.0071 26.2702 15.2307 28.5729C13.2898 31.2324 9.53971 31.8162 6.87514 29.9027C4.17767 27.9891 3.58554 24.2918 5.5264 21.6648C5.5593 21.6 5.62509 21.5351 5.69088 21.4702C15.0662 9.21077 32.7313 6.77834 45.166 16.054C49.2451 19.1027 52.4031 23.1567 54.3111 27.827L43.1593 32.2054Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07217 38.2059C-3.7833 23.9681 3.19063 7.78429 17.6319 2.04375C31.8759 -3.63193 48.0936 2.98429 54.1135 16.9302C55.3965 19.914 54.2122 23.514 51.2187 24.8438C48.2251 26.2059 44.6395 24.9086 43.2579 21.9573C43.225 21.8924 43.1921 21.7951 43.1592 21.7302C39.7709 13.5573 30.3298 9.63294 22.04 12.9735C13.7502 16.314 9.76982 25.6221 13.1581 33.7951L2.07217 38.2059Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9833 29.6757C73.0293 29.5136 72.1082 29.2217 71.2529 28.8001V24.8109C72.174 25.2649 73.128 25.6217 74.1149 25.8811C75.036 26.1082 75.9899 26.2379 76.9768 26.2379C77.6347 26.2703 78.2927 26.1406 78.8848 25.8487C79.2795 25.6217 79.5427 25.2325 79.5098 24.7784C79.5098 24.4541 79.4111 24.1298 79.1808 23.8703C78.8848 23.5784 78.5558 23.319 78.1611 23.1568C77.7334 22.9298 77.0426 22.6379 76.0886 22.2487C74.4438 21.5676 73.2267 20.7892 72.4701 19.946C71.0884 18.292 70.9569 15.9244 72.2069 14.1406C72.8319 13.3298 73.6543 12.6811 74.6083 12.292C75.7268 11.8379 76.9439 11.6109 78.1282 11.6433C79.1151 11.6433 80.069 11.7082 81.0559 11.9028C81.9112 12.0649 82.7336 12.3568 83.5231 12.7136V16.6055C82.1415 15.8595 80.5625 15.4703 78.9835 15.4379C78.3256 15.4055 77.6347 15.5352 77.0426 15.8271C76.5821 16.0217 76.3189 16.4757 76.3189 16.9622C76.3189 17.4487 76.615 17.9028 77.0426 18.1298C77.9308 18.6163 78.8519 19.0055 79.773 19.3622C80.7599 19.7514 81.7138 20.2055 82.602 20.7892C83.2271 21.2109 83.7205 21.7622 84.0823 22.4433C84.4113 23.1892 84.5758 24.0001 84.5429 24.8109C84.5429 26.4325 83.9508 27.6974 82.7336 28.6379C81.5165 29.5784 79.7401 30.0001 77.3387 30.0001C76.1873 30.0001 75.0689 29.8703 73.9833 29.6757Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2728 28.7352C86.4833 27.8919 86.1214 26.7568 86.1214 25.3298V20.5946H84.3779V17.5135H86.1214V13.8811H90.6282V17.5135H93.4243V20.5946H90.6282V24.7135C90.5953 25.2 90.7268 25.7189 90.99 26.1406C91.2532 26.4325 91.6808 26.5622 92.3058 26.5622C92.898 26.5622 93.4901 26.4 93.9835 26.1081V29.4162C93.523 29.6108 93.0625 29.773 92.569 29.8703C91.944 29.9676 91.3519 30.0325 90.7268 30C89.2136 30 88.0623 29.5784 87.2728 28.7352Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7931 28.8974C94.8391 28.1514 94.3128 27.0163 94.3786 25.8163C94.3786 24.4541 94.8391 23.4163 95.7602 22.6703C96.6813 21.9244 97.9642 21.5676 99.6748 21.5676C100.333 21.5676 101.024 21.6325 101.681 21.7947C102.274 21.9244 102.866 22.119 103.392 22.3784V22.119C103.392 20.8217 102.306 20.173 100.168 20.173C98.7537 20.173 97.3392 20.4649 96.0563 21.0163V17.9676C96.7471 17.6757 97.4708 17.4811 98.1945 17.3514C99.1156 17.1893 100.037 17.1244 100.958 17.1244C103.26 17.1244 104.971 17.5784 106.122 18.4866C107.274 19.3947 107.866 20.6271 107.866 22.2487V29.6109H103.655V28.573C103.162 29.0271 102.57 29.3838 101.912 29.6109C101.155 29.8703 100.333 30.0001 99.5103 30.0001C97.9971 30.0001 96.7471 29.6433 95.7931 28.8974ZM102.339 26.9514C102.767 26.7893 103.129 26.4974 103.392 26.1406V25.0703C102.635 24.5838 101.78 24.3244 100.892 24.3568C100.399 24.3244 99.9051 24.4541 99.5103 24.746C99.1814 25.0055 98.984 25.4271 99.0169 25.8487C98.984 26.2703 99.1814 26.6595 99.4774 26.919C99.8722 27.2109 100.366 27.3406 100.859 27.3082C101.352 27.2757 101.879 27.1784 102.339 26.9514Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.037 17.5136H114.379V18.8433C114.905 18.2595 115.563 17.8379 116.287 17.546C117.044 17.2541 117.833 17.1244 118.656 17.1244C120.366 17.1244 121.649 17.5784 122.471 18.4541C123.294 19.3298 123.722 20.5298 123.722 22.0541V29.6109H119.215V22.6379C119.215 21.2757 118.59 20.5947 117.307 20.5947C116.748 20.5947 116.221 20.7244 115.728 20.9838C115.234 21.2757 114.807 21.6974 114.511 22.1839V29.6109H110.004V17.5136H110.037Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2529 35.0596H76.0886L80.6283 46.7677L85.1679 35.0596H89.9707L82.8323 52.6704H78.3913L71.2529 35.0596Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6284 51.373C89.2468 50.2703 88.5889 48.6811 88.5889 46.6703C88.5889 44.6595 89.181 43.0703 90.3981 41.9352C91.6153 40.7676 93.3588 40.1838 95.6615 40.1838C96.9773 40.1514 98.2603 40.4433 99.4445 40.9946C100.431 41.4811 101.287 42.2919 101.813 43.2325C102.372 44.2055 102.635 45.3406 102.635 46.4433V48.0649H92.8653C93.0298 48.7136 93.4904 49.2649 94.1483 49.5244C95.0365 49.8487 95.9905 50.0109 96.9444 49.9784C97.7668 49.9784 98.5892 49.9136 99.4116 49.7838C100.168 49.6865 100.892 49.4919 101.583 49.2325V52.1514C100.826 52.4433 100.037 52.6379 99.2142 52.7676C98.2603 52.9298 97.2734 52.9946 96.3194 52.9946C93.8851 53.0595 92.01 52.4757 90.6284 51.373ZM98.3919 45.3406C98.359 44.7244 98.0629 44.173 97.5695 43.8163C97.0102 43.4271 96.2865 43.2325 95.5957 43.2649C94.9049 43.2325 94.2141 43.4271 93.6548 43.8487C93.1943 44.2379 92.8982 44.7892 92.8324 45.373L98.3919 45.3406Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.412 40.573H108.787V41.9028C109.314 41.319 109.972 40.8974 110.695 40.6055C111.452 40.3136 112.241 40.1838 113.064 40.1838C114.774 40.1838 116.057 40.6379 116.88 41.5136C117.702 42.3892 118.13 43.5892 118.13 45.1136V52.6703H113.623V45.6974C113.623 44.3352 112.998 43.6541 111.715 43.6541C111.156 43.6541 110.629 43.7838 110.136 44.0433C109.643 44.3352 109.215 44.7568 108.919 45.2433V52.6703H104.412V40.573Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.143 51.7946C121.353 50.9514 120.992 49.8162 120.992 48.3892V43.6541H119.248V40.573H120.992V36.9406H125.498V40.573H128.294V43.6541H125.498V47.8054C125.465 48.2919 125.597 48.8108 125.86 49.2324C126.123 49.5243 126.551 49.6541 127.176 49.6541C127.768 49.6541 128.36 49.4919 128.854 49.2V52.5081C128.393 52.7027 127.933 52.8649 127.439 52.9622C126.814 53.0595 126.189 53.0919 125.597 53.0919C124.084 53.0595 122.932 52.6378 122.143 51.7946Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.156 51.6649C130.301 50.7568 129.873 49.5243 129.906 48V40.573H134.413V47.5135C134.413 48.9081 135.038 49.6216 136.321 49.6216C136.88 49.6216 137.439 49.4919 137.9 49.2325C138.393 48.9406 138.788 48.5514 139.084 48.0649V40.6379H143.591V52.7352H139.248V51.4379C138.722 51.9892 138.064 52.4108 137.341 52.7027C136.584 52.9946 135.794 53.1243 134.972 53.1243C133.261 53.0595 132.011 52.573 131.156 51.6649Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.861 40.573H150.204V42.0649C150.763 41.4811 151.454 41.0595 152.21 40.8325C153.131 40.5406 154.118 40.3784 155.105 40.3784V43.7838C154.085 43.7514 153.098 43.9136 152.144 44.2703C151.388 44.4973 150.763 45.0163 150.368 45.6973V52.6703H145.861V40.573Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.967 51.373C156.585 50.2703 155.895 48.6811 155.895 46.6703C155.895 44.6595 156.52 43.0703 157.737 41.9352C158.954 40.7676 160.697 40.1838 163 40.1838C164.316 40.1514 165.599 40.4433 166.783 40.9946C167.77 41.4811 168.592 42.2919 169.152 43.2325C169.711 44.2055 169.974 45.3082 169.974 46.4433V48.0649H160.204C160.368 48.7136 160.829 49.2649 161.487 49.5244C162.375 49.8487 163.329 50.0109 164.283 49.9784C165.105 49.9784 165.928 49.9136 166.75 49.7838C167.507 49.6865 168.231 49.4919 168.954 49.2325V52.1514C168.198 52.4433 167.408 52.6379 166.586 52.7676C165.632 52.9298 164.645 52.9946 163.691 52.9946C161.224 53.0595 159.316 52.4757 157.967 51.373ZM165.698 45.3406C165.665 44.7244 165.369 44.173 164.875 43.8163C164.316 43.4271 163.592 43.2325 162.901 43.2649C162.211 43.2325 161.52 43.4271 160.961 43.8487C160.5 44.2379 160.204 44.7892 160.138 45.373L165.698 45.3406Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.954 52.7676C173.066 52.6379 172.211 52.346 171.389 51.9568V48.7136C173 49.5892 174.777 50.0433 176.619 50.1082C177.047 50.1406 177.507 50.0757 177.935 49.9784C178.165 49.946 178.362 49.719 178.33 49.4919C178.33 49.2973 178.231 49.1028 178.066 49.0055C177.77 48.8109 177.441 48.6811 177.08 48.6163C176.619 48.4865 176.06 48.3244 175.468 48.1622C174.612 47.9352 173.79 47.6109 173 47.2217C172.441 46.9298 172.014 46.5082 171.685 46.0217C171.389 45.4703 171.224 44.8217 171.257 44.173C171.191 42.973 171.783 41.8703 172.836 41.2541C173.889 40.6055 175.303 40.2811 177.145 40.2811C178.099 40.2811 179.02 40.3784 179.941 40.573C180.731 40.7028 181.455 40.9298 182.146 41.2865V44.4973C181.52 44.1082 180.83 43.8487 180.106 43.6541C179.349 43.4595 178.527 43.3298 177.737 43.3298C177.277 43.3298 176.816 43.3622 176.389 43.4919C176.06 43.5892 175.895 43.7838 175.895 44.0757C175.895 44.3676 176.06 44.5298 176.389 44.6595C176.948 44.8541 177.54 45.0487 178.132 45.146C178.691 45.2757 178.889 45.3406 178.823 45.3082C179.711 45.5028 180.566 45.8271 181.356 46.2811C181.882 46.573 182.343 46.9946 182.606 47.546C182.869 48.1298 183.001 48.746 182.968 49.3622C183.001 50.4973 182.409 51.5352 181.455 52.119C180.435 52.8 178.987 53.1244 177.047 53.1244C176.027 53.0595 174.974 52.9622 173.954 52.7676Z",
    fill: "#545454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.6273,
    y1: 33.7018,
    x2: 41.0192,
    y2: 48.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF801F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FF7F1F",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FF701F",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FF621F",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF581E",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF4F1E",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FF491E",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF451E",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF441E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 47.2559,
    y1: 47.1666,
    x2: 8.04397,
    y2: 45.3819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF801F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF7C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF6F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FF5B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 44.853,
    y1: 32.212,
    x2: 15.5111,
    y2: 17.0652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF801F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FF7F1F",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FF701F",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FF621F",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF581E",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF4F1E",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FF491E",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF451E",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF441E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 9.13942,
    y1: 18.7309,
    x2: 48.305,
    y2: 20.3808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF801F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF7C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF6F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FF5B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 66,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3ccfa0c3fe8f53e42d9ac5d76bfd2b9b.svg";
export { ForwardRef as ReactComponent };